export default __webpack_public_path__ + "static/media/aira_img.4e027d13.png";